import React from 'react';
import Pagina1 from './Paginas/Pagina1.js';
import Pagina2 from './Paginas/Pagina2.js';
import Pagina3 from './Paginas/Pagina3.js';
import Pagina4 from './Paginas/Pagina4.js';
import Pagina5 from './Paginas/Pagina5.js';
import Pagina6 from './Paginas/Pagina6.js';
import Pagina7 from './Paginas/Pagina7.js';

function SDTemplate({ data, produtos }) {

  return (
    <>
      <div>
        <Pagina1 {...{ data }}/>
        <Pagina2 {...{ data }}/>
        <Pagina3 {...{ data, produtos }}/>
        <Pagina4 {...{ data }}/>
        <Pagina5 {...{ data }}/>
        <Pagina6 {...{ data }}/>
        <Pagina7 {...{ data }}/>
      </div>
    </>
  );
};

export default SDTemplate;